import React, { useState } from 'react';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { AlignmentPositions, Popover, Tag, TagProps, Typography } from '@guildeducationinc/recess';
import { useIsTablet } from '@guildeducationinc/catalog-tools';
import { GetMemberProgramQuery } from '@src/graphqlTypes/catalogServiceTypes';
import styles from './PopoverTag.module.scss';

export interface CatalogTagProps {
	appearance: TagProps['appearance'];
	color: TagProps['color'];
	copy: string;
	copyColor?: string;
	iconColor?: string;
}

export interface PopoverTagProps {
	onClick?: () => void;
	popoverContent: string | React.ComponentType<unknown>;
	programUuid: GetMemberProgramQuery['memberProgram']['uuid'];
	tag: CatalogTagProps;
}

export const PopoverTag: React.FC<PopoverTagProps> = ({
	onClick,
	popoverContent,
	programUuid,
	tag,
}) => {
	const [showPopover, setShowPopover] = useState(false);
	const isTablet = useIsTablet();

	const handleClick = () => {
		setShowPopover(!showPopover);
		if (onClick) {
			onClick();
		}
	};

	return (
		<Popover
			id='more-info-popover'
			key={tag.copy}
			onOutsideClick={() => {
				setShowPopover(false);
			}}
			popoverContent={popoverContent}
			preferredPositions={
				isTablet ? [AlignmentPositions.bottomMiddle] : [AlignmentPositions.bottomRight]
			}
			show={showPopover}
			triggerRefProp='ref'
		>
			<button
				className={styles.tagButton}
				id={`popover-button-${tag.copy}-${programUuid}`}
				onClick={handleClick}
			>
				<Tag appearance={tag.appearance} className={styles.tag} color={tag.color}>
					<div className={styles.tagContent}>
						<Typography color={tag.copyColor} variant='body1'>
							{tag.copy}
						</Typography>
						<InfoOutlinedIcon
							className={styles.icon}
							color={tag.iconColor}
							size={16}
							testid='popover-icon'
						/>
					</div>
				</Tag>
			</button>
		</Popover>
	);
};
